import FormInput from '../../../form/components/form-input/FormInput/FormInput';

const Input = (props) => {
    const { val, getHandlers } = props;
    const value = val;
    const handlers = getHandlers('change');

    return <FormInput {...props} value={value} handlers={handlers} typeField={'number'} isGridInput={true} />;
};

export default Input;
